import { useDeletePaymentMethodMutation } from "../store/api";
import AuthContext from "../store/AuthContext";
import { CARD_ELEMENT_OPTIONS } from "../store/constants";
import { getPaymentMethod } from "../util/misc";
import {
  checkCardValidity,
  explainDecline,
  stripeErrorMessageParseToObject,
} from "../util/stripe";
import { CardElement } from "@stripe/react-stripe-js";
import { useContext, useEffect, useState } from "react";

import AddCard from "./AddCard";
import CardSelector from "./CardSelector";
import { FieldTitle } from "./FieldTitle";

const CardManagement = ({
  cards,
  elements,
  paymentDate,
  selectedPaymentMethod,
  setCardWillBeValid,
  setSelectedPaymentMethod,
  stripe,
  stripeCustomer,
  cardExpiredText = "Selected card will have expired by the selected date",
}) => {
  const authctx = useContext(AuthContext);
  const { addCardToCustomer, setOverlay } = authctx;

  const [deletePaymentMethod] = useDeletePaymentMethodMutation();

  const removeCard = async (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    try {
      setOverlay(() => "Removing card");
      await deletePaymentMethod({ id: selectedPaymentMethod });
    } finally {
      setOverlay(() => "");
    }
  };

  const addCard = async (event) => {
    setAddCardErr(() => null);
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    try {
      setOverlay(() => "");

      const card = elements.getElement(CardElement);

      const addedPaymentMethod = await addCardToCustomer(
        stripeCustomer.name,
        card,
        stripe,
      );

      setSelectedPaymentMethod(() => addedPaymentMethod);
    } catch (ex) {
      setAddCardErr(() =>
        explainDecline(stripeErrorMessageParseToObject(ex?.message)),
      );
    } finally {
      setOverlay(() => "");
    }
  };

  const [addCardErr, setAddCardErr] = useState(null);

  const [cardValid, setCardValid] = useState(false);

  useEffect(() => {
    // notify parent if passed
    if (setCardWillBeValid) {
      setCardWillBeValid(cardValid);
    }
  }, [cardValid, setCardWillBeValid]);

  useEffect(() => {
    const payMethod = getPaymentMethod(cards, selectedPaymentMethod) || {};
    setCardValid(() =>
      checkCardValidity(payMethod?.card, new Date(paymentDate)),
    );
  }, [paymentDate, cards, selectedPaymentMethod]);
  return (
    <>
      <FieldTitle>Card</FieldTitle>
      <CardSelector
        name="card"
        cards={cards}
        paymentMethod={selectedPaymentMethod}
        setCurrentSource={setSelectedPaymentMethod}
        removeCard={removeCard}
      />
      {/* Add card or request link */}
      <div className={selectedPaymentMethod !== "new" ? "hidden" : ""}>
        <CardElement options={CARD_ELEMENT_OPTIONS} />
      </div>
      {addCardErr && (
        <div className="text-center text-red-500">{addCardErr}</div>
      )}
      {!!(selectedPaymentMethod === "new") && <AddCard onAdd={addCard} />}
      {!cardValid && selectedPaymentMethod !== "new" && (
        <div className="text-red-500">{cardExpiredText}</div>
      )}
    </>
  );
};
export default CardManagement;
